module.exports = __webpack_public_path__ + "img/badge_limited.728caaa4.png";